import helperService from './helperService'

import {getApp} from 'firebase/app'
import {signInWithRedirect,
	signInWithPopup,
	getAuth,
	GoogleAuthProvider,
	OAuthProvider,
	signInWithCustomToken,
	signOut,
	onAuthStateChanged} from 'firebase/auth'

const MicrosoftAuthProvider = new OAuthProvider('microsoft.com')

class AuthService {
	constructor(firebaseApp) {
		this.auth = getAuth(firebaseApp)
	}
	async waitForUser(callback) {
		return onAuthStateChanged(this.auth, async userCred => {
			callback(userCred)
		})
	}

	loginWithGoogle() {
		return signInWithPopup(this.auth, new GoogleAuthProvider())
	}
	loginWithMicrosoft() {
		return signInWithPopup(this.auth, MicrosoftAuthProvider)
	}
	loginWithLink(email, token, alert) {
		// eslint-disable-next-line no-undef
		return new Promise(async (resolve, reject) => {
			if (email) {
				// DEPRECATED
				// window.localStorage.setItem('emailForSignIn', email)
				// const status = await helperService.awaitFetch('/api/auth', {
				// 	action: 'magic',
				// 	email
				// })
				// if (status?.success === false)
				// 	reject('There was an Error')
				// else
				// 	resolve()
			}
			else if (token) {
				const auth = getAuth()
				signInWithCustomToken(auth, token)
					.then((userCredential) => {
						resolve({
							user: userCredential.user
						})
					})
					.catch(function (error) {
						console.log(error)
						alert('Sorry, this token is invalid. Please try again.', 'error', 5000)

						console.log('failed to log in', error)

						reject({
							error
						})
						document.location.href = '/'
					})
			}

		})
	}
	async logout() {
		await signOut(this.auth)
	}
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new AuthService(getApp())
